import React from 'react';
// import NavBar from './components/NavBar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Home from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import Locations from './components/pages/Locations';
import Programs from './components/pages/Programs';
import Footer from './components/Footer';
import ContactUs from './components/pages/ContactUs';
import ComingSoon from './components/ComingSoon';
import NavBarBar from './components/NavBarBar';
import ScrollToTop from './components/ScrollToTop';
import { ColorModeContext, useMode } from './theme';
import { CssBaseline, ThemeProvider,Box } from '@mui/material';
import NotFound from './components/pages/NotFound';
import Policies from './components/pages/Policies';
import Gallery from './components/pages/Gallery';

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme = {theme}>
        <CssBaseline>
          <Router>
            <ScrollToTop />
            <NavBarBar />
            <Box
              component="main"
              sx={(theme) => ({
                paddingTop: { xs: "85px", sm: "94px" }, // Ensure space for Navbar
                minHeight: "100vh", // Full height pages
                position: "relative", // Ensure positioning works for gradient
                zIndex: 1,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 600px", // ✅ Ensures a fixed height for the blur
                backgroundPosition: "top center", // ✅ Locks it to the top
                backgroundImage:
                  "radial-gradient(ellipse 50% 40% at 50% -20%, hsl(211, 100.00%, 78.20%), transparent)", // Light Mode Gradient
                ...theme.applyStyles?.("dark", {
                  backgroundImage:
                    "radial-gradient(ellipse 50% 40% at 50% -20%, hsl(210, 100.00%, 78.50%), transparent)", // Dark Mode Gradient
                }),
              })}
              >
              <Routes>
                <Route path='/' Component={Home}/>
                <Route path="/about-us" Component={AboutUs} />
                <Route path="/locations" Component={Locations} />
                <Route path="/programs" Component={Programs} />
                <Route path="/contact-us" Component={ContactUs} />
                <Route path="/coming-soon" Component={ComingSoon} />
                <Route path="/policies" Component={Policies} />
                <Route path="/gallery" Component={Gallery} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Box>
            <Footer/>
          </Router>
        </CssBaseline>
      </ThemeProvider>
    </ColorModeContext.Provider>
    
  
  );
} 

export default App;
